const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`4088ee0d375ec2022923e1ea0b0edb7908c0fcb5b44fc5e245e53cf86f59720b`, `4088ee0d375ec2022923e1ea0b0edb7908c0fcb5b44fc5e245e53cf86f59720b`, 1, 95), undefined, false, false, 1));
            }

            getTemplateName() {
                return `4088ee0d375ec2022923e1ea0b0edb7908c0fcb5b44fc5e245e53cf86f59720b`;
            }

            getSourceContext() {
                return new this.Source(``, `4088ee0d375ec2022923e1ea0b0edb7908c0fcb5b44fc5e245e53cf86f59720b`, ``);
            }
        }],
        [95, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/bio/bio.twig`, `4088ee0d375ec2022923e1ea0b0edb7908c0fcb5b44fc5e245e53cf86f59720b`, 1);

                this.blocks = new Map([
                    ['avatar', [this, 'block_avatar']],
                    ['content', [this, 'block_content']],
                    ['meta', [this, 'block_meta']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/bio/bio.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_avatar(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/avatar/avatar.twig`, new Map([[`size`, `full`], [`src`, `media/avatar-default.svg`]]), false, false, 3));
                this.echo(`  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, this.loadTemplate(`4088ee0d375ec2022923e1ea0b0edb7908c0fcb5b44fc5e245e53cf86f59720b`, `4088ee0d375ec2022923e1ea0b0edb7908c0fcb5b44fc5e245e53cf86f59720b`, 9, 93), undefined, false, false, 9));
                this.echo(`  `);
            }

            block_meta(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, this.loadTemplate(`4088ee0d375ec2022923e1ea0b0edb7908c0fcb5b44fc5e245e53cf86f59720b`, `4088ee0d375ec2022923e1ea0b0edb7908c0fcb5b44fc5e245e53cf86f59720b`, 24, 94), undefined, true, false, 24));
                this.echo(`  `);
            }

            getTemplateName() {
                return `4088ee0d375ec2022923e1ea0b0edb7908c0fcb5b44fc5e245e53cf86f59720b`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4088ee0d375ec2022923e1ea0b0edb7908c0fcb5b44fc5e245e53cf86f59720b`, ``);
            }
        }],
        [93, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/rhythm/rhythm.twig`, `4088ee0d375ec2022923e1ea0b0edb7908c0fcb5b44fc5e245e53cf86f59720b`, 9);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/rhythm/rhythm.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        <header>
          `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`content`, `Firstname Lastname`], [`subheading`, `Full-time Dreamer`], [`level`, 1]]), false, false, 12));
                this.echo(`        </header>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla leo nunc, finibus at bibendum vitae, aliquam quis lorem. Cras eu felis elit. Morbi eget ligula egestas, aliquet ex at, condimentum nisi. Ut tempus in velit quis ultrices. Duis sodales est augue, non accumsan libero ultrices at. Curabitur vel lacus enim. Proin quis sodales odio. Morbi tincidunt condimentum nulla, eget egestas ipsum mollis ut. Fusce rhoncus semper velit eget porttitor. Integer et nisi volutpat, vehicula mi vitae, euismod libero. Phasellus sit amet tristique ante, nec ultrices purus. Integer elementum lobortis libero, id varius sapien ullamcorper et. Praesent id turpis in leo viverra laoreet non a nibh.</p>
        <p>Etiam at ultrices sem, sit amet fringilla est. Morbi congue eros sed felis posuere viverra. Donec libero mi, ullamcorper id eleifend quis, semper a diam. Ut ultricies metus massa, ac mattis dolor efficitur non. Etiam ullamcorper, neque a venenatis dapibus, erat ipsum consequat leo, id efficitur eros massa quis tortor. Cras eu gravida ipsum. Proin ut gravida felis, sit amet tempus nunc. Sed egestas consectetur dui in scelerisque. Etiam luctus odio dui, a maximus purus luctus et. Aenean vestibulum ipsum at elit tempor consectetur. Aliquam tristique laoreet sagittis. Etiam hendrerit finibus purus in efficitur. Nam sit amet quam id orci aliquet tristique. Sed iaculis nulla sed tristique molestie. Mauris id ligula mi.</p>
      `);
            }

            getTemplateName() {
                return `4088ee0d375ec2022923e1ea0b0edb7908c0fcb5b44fc5e245e53cf86f59720b`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4088ee0d375ec2022923e1ea0b0edb7908c0fcb5b44fc5e245e53cf86f59720b`, ``);
            }
        }],
        [94, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/list/list.twig`, `4088ee0d375ec2022923e1ea0b0edb7908c0fcb5b44fc5e245e53cf86f59720b`, 24);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/list/list.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        <li><a href="#">Website link</a></li>
        <li><a href="#">Website link</a></li>
        <li><a href="#">Social media link</a></li>
        <li><a href="#">Social media link</a></li>
      `);
            }

            getTemplateName() {
                return `4088ee0d375ec2022923e1ea0b0edb7908c0fcb5b44fc5e245e53cf86f59720b`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4088ee0d375ec2022923e1ea0b0edb7908c0fcb5b44fc5e245e53cf86f59720b`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '4088ee0d375ec2022923e1ea0b0edb7908c0fcb5b44fc5e245e53cf86f59720b');

let template = env.loadTemplate('4088ee0d375ec2022923e1ea0b0edb7908c0fcb5b44fc5e245e53cf86f59720b');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/bio/demo/demo.twig", args: context }
     );
     return rendered;;
};